<template>
        <div class="bg-wrap">
            <div class="kv">
            </div>
             <div class="content-wrap">
                    <span class="title">{{title}}</span>
                    <span class="a">必答题</span>
                    <label class="b" @click="toHostStart(type)">开题</label>
                    <label class="d" @click="toScreen">投屏</label>
                    <span class="c">{{hint}}</span>
             </div>
        </div>
</template>

<script>
    import {hostStart} from "../../assets/js/api";

    export default {
        data(){
            return{
                title:"共话新知",
                hint:"（每题1分，共10道题目，答题时间5分钟）",
                type: 1
            }
        },
        methods:{
            async toHostStart(type){
                let res = await hostStart({type})
                console.log(res,"a===")
                if(res.data.success==true){
                    this.$toast("开题成功")
                }
            },
            toScreen() {
                this.$router.push({path:"hostPlayer"})
            }
        }

    }
</script>

<style scoped lang="scss">
    .bg-wrap{
        width: 100%;
        /*max-width: 375px;*/
        height: 100vh;
        background: #FFF url("../../assets/img/answer_bg.png") no-repeat;
        background-size: 100% 100%;
        margin: 0 auto;
    }
    .kv{
        width: 100%;
        height: 250px;
        background: #FFF url("../../assets/img/answer_kv.png") no-repeat;
        background-size: 100% 100%;
        margin: 0 auto;
        position: relative;
    }
    .content-wrap{
        display: flex;
        flex-flow: column;
        align-items: center;
    }
    .content-wrap .title{
        color: #FFF;
        font-size: 38px;
        font-weight: bold;
        font-style: italic;
        letter-spacing: 3px;
    }

    .a{
        color: #FFF;
        font-size: 25px;
        margin-top: 20px;
        opacity: 0.8;
    }
    .b{
        color: #000;
        margin-top: 30px;
        font-size: 14px;
        width: 85%;
        height: 32px;
        line-height: 32px;
        border-radius: 15px;
        background: #ffdb36;
        display: block;

    }
    .c{
        margin-top: 10px;
        color: #FFF;
        font-size: 15px;
        opacity: 0.8;
    }
    .d{
        color: #000;
        margin-top: 10px;
        font-size: 14px;
        width: 85%;
        height: 32px;
        line-height: 32px;
        border-radius: 15px;
        background: #4caf50;
        display: block;

    }

</style>
